import { PureComponent } from "react";
import { componentStyles } from "./footer-bottom-bar-security-link-component.scss";
import { withGenericConfig } from "contexts/generic-config-context";
import SecurityLogosComponent from "../../../security-logos/security-logos-component";
import FooterBottomBarLink from "../footer-bottom-bar-link/footer-bottom-bar-link-component";

class FooterBottomBarSecurityLink extends PureComponent {
  constructor(props) {
    super(props);
  }

  render() {
    const { localeId, ...linkData } = this.props;

    return (
      <div className="footer-bottom-bar-security-link-component">
        <FooterBottomBarLink localeId={localeId} {...linkData} />

        <div className="security-logos-wrapper">
          <SecurityLogosComponent />
        </div>
        <style jsx>{componentStyles}</style>
      </div>
    );
  }
}

export default withGenericConfig(FooterBottomBarSecurityLink);
